/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FemurTable.vue?vue&type=template&id=a2d6f664"
import script from "./FemurTable.ts?vue&type=script&lang=js&external"
export * from "./FemurTable.ts?vue&type=script&lang=js&external"
import style0 from "./FemurTable.vue?vue&type=style&index=0&id=a2d6f664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports